'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Control = require('../Control');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxGroup = function CheckboxGroup(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === undefined ? [] : _ref$value,
      _onChange = _ref.onChange,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? [] : _ref$options,
      props = (0, _objectWithoutProperties3.default)(_ref, ['value', 'onChange', 'options']);
  return options.map(function (option) {
    return _react2.default.createElement(_Control.Checkbox, (0, _extends3.default)({}, props, option, {
      key: option.value,
      value: contains(value, option.value),
      onChange: function onChange(checked) {
        return _onChange(toggleOption(value, options, option.value, checked));
      },
      label: option.label
    }));
  });
};

function toggleOption(values, options, optionValue, checked) {
  return options.filter(function (_ref2) {
    var value = _ref2.value;

    if (optionValue !== value) {
      return contains(values, value);
    } else {
      return checked;
    }
  }).map(function (_ref3) {
    var value = _ref3.value;
    return value;
  });
}

function contains(values, value) {
  return Array.isArray(values) && values.indexOf(value) !== -1;
}

exports.default = CheckboxGroup;